/**
 * Notification Deep Link - BStock frontend
 *
 * Build the in-app URL for a notification based on its entityType + entityId.
 * The backend doesn't know about frontend routes, so this computation lives here.
 */

import type { NotificationEntityType } from '@bstock/shared';

const DEEP_LINK_MAP: Record<NotificationEntityType, (id: string) => string> = {
  TRANSFER: (id) => `/stock/transferts/${id}`,
  INVENTORY: (id) => `/stock/inventaires/${id}/details`,
  GOODS_RECEIPT: (id) => `/achats/receptions/${id}`,
  PURCHASE_ORDER: (id) => `/achats/commandes/${id}`,
  LOSS: () => `/stock/pertes`,
  RAW_PRODUCT: (id) => `/stock/actuel/${id}`,
};

/**
 * Compute the deep link URL for a notification.
 * Returns null if the entityType is unknown or not mapped.
 */
export function computeNotificationDeepLink(
  entityType: NotificationEntityType | null,
  entityId: string | null
): string | null {
  if (!entityType) return null;
  const builder = DEEP_LINK_MAP[entityType];
  if (!builder) return null;
  return builder(entityId || '');
}
